import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agreements-app',
  templateUrl: './agreements-app.component.html',
  styleUrls: ['./agreements-app.component.css']
})
export class AgreementsAppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/agreements-app/agreements-app.component.ts